var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.content),function(item,idx){return _c('div',{key:idx,staticStyle:{"display":"none"},attrs:{"data-metrika":_vm.metrikaKey[idx]},domProps:{"innerHTML":_vm._s(item)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }